import CustomerAPI from 'config/api/CustomerAPI';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';
export const getAddressList = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.addressList.url,
    CustomerAPI.addressList.method,
    data
  );
  return response;
};
export const addAddressData = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.addAddress.url,
    CustomerAPI.addAddress.method,
    data
  );
  return response;
};
export const getSingleAddressInfo = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.singleAddressInfo.url,
    CustomerAPI.singleAddressInfo.method,
    data
  );
  return response;
};
export const updateAddressData = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.updateAddress.url,
    CustomerAPI.updateAddress.method,
    data
  );
  return response;
};
export const deleteAddress = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.deleteAddress.url,
    CustomerAPI.deleteAddress.method,
    data
  );
  return response;
};
